export default {
  order: {
    sales: {
      ConfirmReceipt: '确认收货',
      BaseInfo: '基本信息',
      DeliverInfo: '发货信息',
      DeliverStore: '发货仓库',
      OrderQuantity: '订单数量',
      DeliverableQuantity: '可发数量',
      DeliveryQuantity: '交货数量',
      UnauditedQuantity: '未审核数量',
      InventoryQuantity: '库存数量',
      ThisQuantity: '本次数量',
      DeliveryTime: '交货日期',
      Quantity: '数量',
      OrderNo: '订单编号',
      DeliverOrderNo: '发货单编号',
      ReceiptNo: '收款单编号',
      Payee: '收款人',
      OrderDate: '下单日期',
      OrderTime: '下单时间',
      DeliverDate: '订货日期',
      LogisticsCompany: '物流公司',
      LogisticsNumber: '物流单号',
      Customer: '客户',
      Receiver: '收货人',
      Consignor: '发货人',
      Telephone: '联系电话',
      OrderStatus: '订单状态',
      PayStatus: '支付状态',
      PaymentMethod: '支付方式',
      BankCardPayment: '银行卡支付',
      AdvancePayment: '预收款支付',
      Balance: '余额',
      Begin: '开始日期',
      End: '结束日期',
      CollectedDate: '收款日期',
      PleaseChooseCollectedDate: '请选择收款日期',
      PaymentAccount: '收款账户',
      PleaseChoosePaymentAccount: '请选择收款账户',
      Address: '收货地址',
      DeliverTime: '交货日期',
      Amount: '金额',
      DiscountAmount: '优惠金额',
      OrderAmount: '订单金额',
      RefundAmount: '退款金额',
      ReceivedAmount: '已收金额',
      UnpaidAmount: '未收金额',
      CollectedAmount: '收款金额',
      Discount: '折扣',
      OrderPrice: '订货价格',
      Source: '来源',
      Deliver: '发货',
      Gathering: '收款',
      Unpaid: '未付款',
      PartialPayment: '部分付款',
      Paid: '全部付款',
      PendingApproval: '待审核',
      Refused: '已拒审',
      Deleted: '已删除',
      AdminCancel: '管理员取消',
      CustomCancel: '客户取消',
      Undelivered: '待发货',
      ToAudit: '待审核',
      PartialDeliver: '部分发货',
      Delivered: '全部发货',
      Recovered: '已收回',
      Completed: '已完成',
      Total: '共',
      CancelOrderConfirm: '确认取消该订单?',
      DeleteOrderConfirm: '确认删除该订单?',
      selectOrderTips: '请选择订单',
      CheckOrderTips: '通过或者拒绝选中订单',
      CheckOrderTitle: '订单审核',
      CheckPass: '通过',
      CheckRefuse: '拒绝',
      NotPass: '不通过',
      DeliverCheckTips: '订单已发货，请前往发货单列表审核',
      Gift: '赠',
      PleaseChooseTheReceivingAddress: '请选择收货地址',
      PleaseChooseTheDeliveryWarehouse: '请选择发货仓库',
      PleaseChooseTheShipper: '请选择发货人',
      PleaseChooseLogisticsCompany: '请选择物流公司',
      PleaseChooseReceiver: '请选择收货人姓名',
      PleaseChooseProvince: '请选择省份',
      PleaseChooseCity: '请选择城市',
      PleaseChooseArea: '请选择区域',
      SaveAndUse: '保存并使用',
      UseNewAddress: '使用新地址',
      SetAsDefault: '设为默认',
      Default: '默',
      PleaseChooseAddress: '收货地址选择',
      PleaseChooseUnapprovedOrder: '请选择未审核订单'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/ims/order.js